import { render, staticRenderFns } from "./supplierLevel.vue?vue&type=template&id=89477fba&scoped=true"
import script from "./supplierLevel.vue?vue&type=script&lang=js"
export * from "./supplierLevel.vue?vue&type=script&lang=js"
import style0 from "./supplierLevel.vue?vue&type=style&index=0&id=89477fba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89477fba",
  null
  
)

export default component.exports